import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('companyDetailsEditCard');

    return {
        TITLE: t('title')
    };
};

export default useTranslation;
